module.exports = __webpack_public_path__ + "img/53-ABITO-DOLCETTO-U-COLORI-LINO-STAMPE-LINO9.91b5759c.jpg";